import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export const attendanceKeys = {
    all: ['attendance'],
    lists: () => [...attendanceKeys.all, 'list'],
    list: (orgId, params) => [...attendanceKeys.lists(), orgId, params],
    details: () => [...attendanceKeys.all, 'detail'],
    detail: (id) => [...attendanceKeys.details(), id],
};

// Fetch attendance list (can filter by month, year, etc.)
export function useAttendance(orgId, params = {}) {
    return useQuery({
        queryKey: attendanceKeys.list(orgId, params),
        queryFn: () => apiHelper.getResource('/emp/attendance/', { params, orgId }),
        enabled: !!orgId,
    });
}

// Clock In / Check In
export function useClockIn() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ data, orgId }) =>
            apiHelper.postResource('/emp/attendance/check-in/', data, { orgId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: attendanceKeys.lists() });
        },
    });
}

// Clock Out / Check Out
export function useClockOut() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data, orgId }) =>
            apiHelper.patchResource(`/emp/attendance/${id}/check-out/`, data, { orgId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: attendanceKeys.lists() });
        },
    });
}
